
namespace Matrix.Data {

    import fld = TestResultRow.Fields;
    @Serenity.Decorators.registerClass()
    export class TestResultGrid extends SiteEntityGrid<TestResultRow, any> {
        protected getColumnsKey() { return 'Data.TestResult'; }
        protected getDialogType() { return TestResultDialog; }
        protected getIdProperty() { return TestResultRow.idProperty; }
        protected getLocalTextPrefix() { return TestResultRow.localTextPrefix; }
        protected getService() { return TestResultService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            var q = Q.parseQueryString() as any;
            if (Q.toId(q.batch))
                this.setEquality(TestResultRow.Fields.BatchId, Q.toId(q.batch));
        }

        getColumns() {
            var columns = super.getColumns();

            var resultCode = Q.tryFirst(columns, x => x.field === TestResultRow.Fields.ResultCode);
            if (resultCode) {
                resultCode.format = ctx => {
                    if (!ctx.value)
                        return "";

                    var color;
                    if (ctx.value === "PASS")
                        color = "green";
                    else if (ctx.value == "FAIL")
                        color = "red";
                    else if (ctx.value == "WARN")
                        color = "orange";
                    else if (ctx.value == "IGNORE")
                        color = "gray";
                    else
                        color = "black";

                    return `<span class="text-${color}"><i class="fa fa-dot-circle-o"></i> ${Q.htmlEncode(ctx.value)}</span>`;
                };
            }



            columns.splice(4, 0, {
                field: 'Mute',
                name: '',
                width: 35,
                minWidth: 35,
                maxWidth: 35,
                format: (ctx: { item: TestResultRow }) => {
                    if (ctx.item.ResultCode === "PASS")
                        return "";

                    if (!ctx.item.MuteUntil || isDateInPast(ctx.item.MuteUntil))
                        return `<a class="inline-action mute" title="New Mute"><i class="mdi mdi-volume-off text-purple" style="font-size: 19px"></i></a>`

                    return `<a class="inline-action mute" title="Edit Mute\nMuted Until: ${Q.formatDate(ctx.item.MuteUntil)}${ctx.item.MuteComment ? "\nComment: " + ctx.item.MuteComment : ""}"><i class="mdi mdi-volume-off text-gray" style="font-size: 19px"></i></a>`
                },
                headerFilterType: Serenity.HeaderFilterType.disabled
            });

            return columns;
        }

        protected getIncludeColumns(include) {
            super.getIncludeColumns(include);

            include[fld.MuteId] = true;
            include[fld.MuteUntil] = true;
            include[fld.MuteComment] = true;
        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as TestResultRow;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('mute')) {

                    const muteDialog = new TestResultMutingDialog();
                    muteDialog.element.on('dialogclose panelclose', () => this.refresh());

                    const showOldData = !isDateInPast(item.MuteUntil);
                    muteDialog.execute({
                        BatchId: item.BatchId,
                        TestCode: item.TestCode,
                        MuteId: item.MuteId,
                        UntilWhen: showOldData ? item.MuteUntil : null,
                        Comment: showOldData ? item.MuteComment : null
                    });
                }
            }
        }
    }
}